import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate, Link } from "react-router-dom";
import { fetchBillSuccess, fetchBill } from "../../redux/action";
import ManualUpi from "../../component/Payment/ManualUpi";
import DynamicUpi from "../../component/Payment/DynamicUpi";
import PaymentSuccessBox from "../../component/Payment/PaymentSuccessBox";
import { useRazorpay } from "../../component/Payment/Razorpay";
import SkeletonPage from "../../component/Skeleton/SkeletonPage";
import { submitPayment } from "../../redux/action";
import "./PayBillPage.scss";
import EmptyHungryPage from "../../component/EmptyHungry/EmptyHungryPage";
import { useTableSessionEvent } from "../../component/TableSessionProvider";

const PayBillPage = () => {
  const orderItems = [
    { id: 1, name: "Tandoori Soya Chaap Malai", qty: 1, price: 326.4 },
    { id: 2, name: "French Fry Peri Peri", qty: 1, price: 240.55 },
  ];

  const [liveDiscount, setLiveDiscount] = useState(0);
  const [liveServiceChargeApplied, setLiveServiceChargeApplied] =
    useState(true);
  const { restaurant, id, table } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const menuList = useSelector((state) => state?.user.menu);
  const cart = useSelector((state) => state?.user.cart);
  const bill = useSelector((state) => state?.user.bill);
  const user = useSelector((state) => state?.user.user);
  const allInfo = JSON.parse(localStorage.getItem("allInfo")) || {};
  const loading = useSelector((state) => state.loading);
  const [showUpi, setShowUpi] = useState(false);
  const [paymentSubmitted, setPaymentSubmitted] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [upiLink, setUpiLink] = useState("");
  const isRazorpayLoaded = useRazorpay();
  let tableSessionAllInfo = null;
  const tableOtp = allInfo?.tableOtp;
  const statusTimer = useRef(null);
  useEffect(() => () => clearTimeout(statusTimer.current), []);

  useTableSessionEvent("ReceiveBillStatus", data => {
    // Preserve the existing payment guard, feedback and two-second redirect.
    if (data.isPaid === true || data.status === "Paid" || data.status === "Void") {
      setVerifying(true);
      localStorage.removeItem("allInfo");
      clearTimeout(statusTimer.current);
      statusTimer.current = setTimeout(() => {
        navigate(`/${restaurant}/${id}/${table}/PaymentStatus/${data.status}`);
      }, 2000);
    }
  });

  useTableSessionEvent("ReceiveLiveBillModification", data => {
    if (data.discountAmount !== undefined)
      setLiveDiscount(Number(data.discountAmount));
    if (data.isServiceChargeApplied !== undefined)
      setLiveServiceChargeApplied(data.isServiceChargeApplied);
  });

  try {
    const data = localStorage.getItem("allInfo");
    tableSessionAllInfo = data ? JSON.parse(data) : null;
  } catch (error) {
    console.error("Invalid JSON in localStorage", error);
  }
  console.log("bill from enduser", bill);
  console.log("user from enduser", user);
  console.log("tableSessionAllInfo from enduser", tableSessionAllInfo);

  // 1️⃣ Fetch bill (independent)
  useEffect(() => {
    // dispatch(fetchBill("999"));
    if (tableOtp) dispatch(fetchBill(tableOtp));
  }, [dispatch, tableOtp]);

  // 2️⃣ Start SignalR when user data is ready
  // useEffect(() => {
  //   if (bill) {
  //     console.log("startSignalR useEffect....",tableSessionAllInfo?.restaurantOrBranchId, tableSessionAllInfo?.tableNumber)
  //     dispatch(startSignalR({
  //       restaurantId: tableSessionAllInfo?.restaurantOrBranchId,
  //       tableNumber: tableSessionAllInfo?.tableNumber
  //     }));
  //   }
  // }, [tableSessionAllInfo?.restaurantOrBranchId, tableSessionAllInfo?.tableNumber, dispatch]);

  // useEffect(() => {

  //   if (bill && tableSessionAllInfo?.tableOtp) {
  //     console.log("paybill.js startSignalR")
  //     dispatch(startSignalR({ tableOtp: tableSessionAllInfo.tableOtp }));
  //   }

  //   return () => {
  //     // Dispatch an action to stop the saga/connection if user leaves early
  //      console.log("paybill.js STOP_SIGNALR")
  //     dispatch({ type: "STOP_SIGNALR" });
  //   };
  // }, [tableSessionAllInfo?.tableOtp]);

  const itemTotal = Number(
    bill?.orders
      ?.reduce((sum, item) => sum + item.quantity * item.price, 0)
      .toFixed() || 0,
  );

  console.log("bill.........", bill);
  //const itemTotal = getTotalPrice();

  const {
    cgst = 0,
    sgst = 0,
    serviceCharge = 0,
    showCGST,
    showSGST,
    showServiceCharge,
  } = bill.charges || [];

  //const itemTotal = 326.4 + 240.55;
  // serviceCharge = showServiceCharge? (itemTotal * serviceCharge) / 100: 0;
  // cgst = showCGST ? (itemTotal * cgst) / 100 : 0;
  // sgst = showSGST ? (itemTotal * sgst) / 100 : 0;
  // const taxTotal = serviceCharge + cgst + sgst;
  // const roundOff = 0.37;
  // const grandTotal = Math.round(itemTotal + taxTotal + roundOff);

  //const { cgst, sgst, serviceCharge, showCGST, showSGST, showServiceCharge } = billDetails.charges || [];
  const cgstAmount = showCGST ? Number((itemTotal * cgst) / 100) : 0;
  const sgstAmount = showSGST ? Number((itemTotal * sgst) / 100) : 0;

  const isServiceChargeActive = showServiceCharge && liveServiceChargeApplied;
  const serviceChargeAmount = isServiceChargeActive
    ? Number((itemTotal * serviceCharge) / 100) || 0
    : 0;

  //const serviceChargeAmount = showServiceCharge ? Number((itemTotal * serviceCharge) / 100) || 0: 0;
  const taxTotal = serviceChargeAmount + cgstAmount + sgstAmount;

  const totalBeforeDiscount = Number(itemTotal + taxTotal).toFixed(2) || 0;
  //const totalBeforeDiscount = Number(itemTotal + cgstAmount + sgstAmount + serviceChargeAmount).toFixed(2) || 0;

  const grandTotal = Math.max(
    Number(totalBeforeDiscount - liveDiscount).toFixed(2),
    0,
  );
  //const grandTotal = Math.max(Number(totalBeforeDiscount).toFixed(2), 0);

  const roundedTotal = Math.round(grandTotal);
  const roundOff = Number((roundedTotal - grandTotal).toFixed(2));
  const payableAmount = roundedTotal.toFixed(2);

  const {
    razorpayKeyId,
    paymentModeId,
    razorpayAccountId,
    razorpayEnabled,
    razorpayKeySecret,
    upiId,
  } = bill?.restaurantPaymentConfig || [];

  const handleRazorpayPayment = (payableAmount) => {
    if (!isRazorpayLoaded || !window.Razorpay) {
      alert("Razorpay SDK not loaded yet. Please try again.");
      return;
    }

    const options = {
      key: razorpayKeyId, // ✅ no Object.value
      amount: Math.round(Number(payableAmount) * 100),
      currency: "INR",
      name: restaurant,
      description: `${table || "Table"} Payment`,
      prefill: {
        name: user?.name,
        email: user?.email,
        contact: user?.contactNumber,
      },
      theme: {
        color: "#3399cc",
      },
      handler: function (response) {
        console.log("Payment Success", response);
        setVerifying(true);
        handlePaymentSubmit(payableAmount, "Razorpay");
      },
    };

    //  RazorpayCheckout.open(options).then((data) => {
    //   // handle success
    //   alert(`Success: ${data.razorpay_payment_id}`);
    // }).catch((error) => {
    //   // handle failure
    //   alert(`Error: ${error.code} | ${error.description}`);
    // });

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  const data = (paymentMethod, paymentStatus) => ({
    qRScanLogId: tableSessionAllInfo?.qrScanLogId || user?.qrScanLogId,
    tableNumber: "T-" + table,
    subTotal: itemTotal.toFixed(2),
    serviceChargePercent: serviceCharge,
    serviceChargeAmount: serviceChargeAmount,
    isServiceChargeApplied: true,
    cGSTPercent: cgst,
    cGSTAmount: cgstAmount,
    sGSTPercent: sgst,
    sGSTAmount: sgstAmount,
    discountAmount: 0,
    grandTotal: grandTotal,
    settlementAmount: payableAmount,
    changeReturn: 0,
    paymentMode: paymentMethod,
    orderMode: "DINE_IN",
    isPaid: true,
    billStatus: paymentStatus,
  });

  const handlePaymentSubmit = (payableAmount, method) => {
    setVerifying(true);
    if (method === "UPI")
      dispatch(
        submitPayment(data(method, "Payment under review"), bill.orders),
      );
    else dispatch(submitPayment(data(method, "Paid"), bill.orders));
  };

  const hasValidTableOtp =
    tableOtp !== undefined && tableOtp !== null && tableOtp !== "";

  if (!hasValidTableOtp) {
    return <EmptyHungryPage text={"generate your bill"} />;
  }

  if (loading) {
    return <SkeletonPage />;
  }

  return (
    <div className="paybill-container">
      {/* Order List */}
      <div className="order-table-wrapper">
        <table className="order-table">
          <thead>
            <tr>
              <th>No.</th>
              <th>Item Name</th>
              <th>Qty</th>
              <th>Price</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {bill.orders &&
              Object.values(bill.orders).map((item, index) => (
                <tr key={item.menuId}>
                  <td>{index + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.quantity}</td>
                  <td>₹{item.price.toFixed(2)}</td>
                  <td>₹{(item.quantity * item.price).toFixed(2)}</td>
                </tr>
              ))}
          </tbody>
          <tfoot>
            <tr className="grand-total">
              <td colSpan="4">
                <strong>Item Total</strong>
              </td>
              <td>
                <strong>₹{itemTotal.toFixed(2)}</strong>
              </td>
            </tr>
          </tfoot>
        </table>

        {/* <div className="item-total">
          <span>Item Total</span>
          <span>₹{itemTotal.toFixed(2)}</span>
        </div> */}
      </div>

      {/* Taxes */}
      <div className="section-title">Taxes & Charges</div>

      <div className="section-card">
        {serviceChargeAmount > 0 && (
          <div className="tax-row">
            <span>Service Charge @ {serviceCharge.toFixed(2)}%</span>
            <span>₹{serviceChargeAmount.toFixed(2)}</span>
          </div>
        )}

        <div className="tax-row">
          <span>CGST @ {cgst.toFixed(2)}%</span>
          <span>₹{cgstAmount.toFixed(2)}</span>
        </div>
        <div className="tax-row">
          <span>SGST @ {sgst.toFixed(2)}%</span>
          <span>₹{sgstAmount.toFixed(2)}</span>
        </div>

        <div className="item-total">
          <span>Taxes & Charges Total</span>
          <span>₹{taxTotal.toFixed(2)}</span>
        </div>
      </div>

      {/* Payable Amount */}
      <div className="section-title">Payable Amount</div>

      <div className="section-card">
        <div className="tax-row">
          <span>Item Total</span>
          <span>₹{itemTotal.toFixed(2)}</span>
        </div>
        <div className="tax-row">
          <span>Taxes & Charges Total</span>
          <span>₹{taxTotal.toFixed(2)}</span>
        </div>

        {liveDiscount > 0 && (
          <div className="tax-row">
            <span>Discount</span>
            <span>₹{liveDiscount.toFixed(2)}</span>
          </div>
        )}
        <div className="tax-row">
          <span>Round Off</span>
          <span>₹{roundOff.toFixed(2)}</span>
        </div>

        <div className="grand-total-row">
          <span>Total Payable Amount</span>
          <span className="grand-amount">₹{payableAmount}</span>
        </div>
      </div>

      {paymentModeId === 1 && (
        <>
          {/* Manual UPI */}
          <button className="pay-btn btn" onClick={() => setShowUpi(true)}>
            Pay Bill ₹{payableAmount}
          </button>
          <p className="bottom-note">
            Pay Bill on this app, avoid waiting for Bill!
          </p>

          {showUpi && (
            <ManualUpi
              grandTotal={payableAmount}
              bill={bill}
              onPaymentSubmit={handlePaymentSubmit}
            />
          )}
        </>
      )}

      {paymentModeId === 2 && (
        <>
          {/* Dynamic UPI */}
          <button
            className="pay-btn btn"
            onClick={() =>
              setUpiLink(
                "upi://pay?pa=" +
                  upiId +
                  "&pn=" +
                  restaurant +
                  "&am=" +
                  grandTotal +
                  "&cu=INR&tn=" +
                  "Table " +
                  tableSessionAllInfo.tableNumber ||
                  user.tableNumber + " | Order ORD123",
              )
            }
          >
            Pay Bill ₹{grandTotal}
          </button>
          <p className="bottom-note">
            Pay Bill on this app, avoid waiting for Bill!
          </p>

          {upiLink && (
            <DynamicUpi
              grandTotal={payableAmount}
              upiLink={upiLink}
              table={user.tableNumber || tableSessionAllInfo.tableNumber}
              onPaymentSubmit={() => handlePaymentSubmit(payableAmount, "UPI")}
            />
          )}
        </>
      )}

      {paymentModeId === 7 && (
        <>
          {/* Razorpay */}
          <button
            className="pay-btn btn"
            onClick={() => handleRazorpayPayment(payableAmount, "Razorpay")}
          >
            Pay Bill (Razorpay) ₹{payableAmount}
          </button>
          <p className="bottom-note">
            Pay Bill on this app, avoid waiting for Bill!
          </p>
        </>
      )}

      {verifying && <PaymentSuccessBox />}
    </div>
  );
};

export default PayBillPage;
